import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputTerminAnhang<T extends EMode = EMode.entity> {
  /** Alias: code */
  code?: number;
  /** Alias: filename */
  filename?: string;
  /** Alias: notiz */
  notiz?: string;

  __typename?: string;
}

const fields: FieldDefinitions<InputTerminAnhang> = {
  code: {
    alias: 'code',
  },
  filename: {
    alias: 'filename',
  },
  notiz: {
    alias: 'notiz',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputTerminAnhangEntityDefinition: EntitiyDefinition<InputTerminAnhang> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputTerminAnhang',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
